import React from 'react';

import type { IKlpStyles } from '@klp/design';
import { useKlpStyles } from '@klp/design/Theme';

const crumbStyles = () => ({
    separator: {
        display: 'flex',
        userSelect: 'none',
        marginLeft: 8,
        marginRight: 8,
        '&:first-of-type': {
            marginLeft: 0,
        },
    },
});

export const Crumb: React.FC<IKlpStyles> = (props) => {
    const { children } = props;
    const classes = useKlpStyles(props, crumbStyles);

    return (
        <>
            <span className={classes.separator}>{'<'}</span>
            {children}
        </>
    );
};
